import { Language } from '../ts/customTypes';
import { Pages } from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/de/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/de/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/de/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/de/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/de/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/de/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/de/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/de/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import { IconBestellschnittstelle } from '../../lib/components/content/IconBestellschnittstelle';
import { IconKatalogschnittstelle } from '../../lib/components/content/IconKatalogschnittstelle';
import { IconVerfuegbarkeitsschnittstelle } from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import { IconNettopreisschnittstelle } from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-de.svg';

export const de: Language = {
    id: 'DE',
    languageName: 'Deutsch',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Übersicht',
    infolayer: {
        text: (
            <>
                <p>Wir freuen uns, dass Sie mehr über die OMNIplus eProcurement-Schnittstellen erfahren möchten.</p>
                <p>
                    Die Website ist optimiert für die Darstellung auf einem Desktop-Computer oder Tablet. Eine
                    Darstellung auf Ihrem Mobilgerät ist leider nicht möglich.
                </p>
                <p>
                    Über die Webadresse dieser Seite können Sie die Inhalte auch auf anderen Endgeräten öffnen. Schicken
                    Sie einfach die Adresse dieser Seite an ein Tablet oder Ihren Computer. Klicken Sie auf folgenden
                    Link, um die Webadresse in die Zwischenablage zu kopieren:
                </p>
            </>
        ),
        button: 'Link in Zwischenablage kopieren',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Beschaffungsprozess',
        headlineWidth: 470,
        buttonContact: 'Kontakt',
        buttonTestimonials: 'Kundenfeedback',
        tooltips: {
            availability: 'Verfügbarkeits-\nschnittstelle',
            catalogue: 'Katalog-\nschnittstelle',
            identification: 'Teileidentifikation',
            order: 'Bestellschnittstelle',
            price: 'Nettopreis-\nschnittstelle',
            storage: 'Disposition\nbekannter\nErsatzteile',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Kundenfeedback',
        headlineWidth: 420,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Technischer Mitarbeiter bei der Usedomer Bäderbahn GmbH',
                quotes: [
                    '„Die Einrichtung der neuen Schnittstelle zu COSware hat gut funktioniert. Dadurch ist es uns nun möglich, Ersatzteile zeiteffizienter ins System aufzunehmen und zu bestellen.“',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Fachbereichsleiter Einkauf bei Stuttgarter Straßenbahnen AG',
                quotes: [
                    '„In kürzester Zeit wurde ein Projekt aufgesetzt, um die Anbindung unseres Beschaffungssystem mit OMNIplus zu realisieren.“',
                    '„Hervorzuheben ist die pragmatische und zielführende Vorgehensweise.“',
                    '„Heute profitieren wir im Einkauf und in unseren Werkstätten von den gesunkenen Beschaffungskosten.“',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Einkauf bei der Holding Graz - Kommunale Dienstleistungen GmbH',
                quotes: [
                    '„Mit der Implementierung haben wir den Beschaffungsprozess auch im Umfeld optimiert. Dieser Nebennutzen war für uns ebenso bedeutend, wie die Schnittstellen selbst.“',
                    '„Schon in kürzester Zeit hat sich die Anbindung so bewährt, dass sie nicht mehr wegzudenken ist.“',
                ],
            },
        ],
        footer: {
            headline: 'Unsere Schnittstellen sind im Einsatz bei:',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungen GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Kontakt',
        headlineWidth: 250,
        texts: [
            'Bei der Implementierung von eProcurement-Schnittstellen stehen Ihre Prozesse im Fokus: Daher unterstützen wir Sie bei Ihrem kundenindividuellen Anbindungsprojekt zur Digitalisierung Ihrer Beschaffung.',
            'Kontaktieren Sie uns gerne unter: ',
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'Üblicherweise verläuft jedes Anbindungsprojekt in vier Schritten:',
        steps: ['Kick-off', 'Konzeptionierung', 'Implementierung', 'Go-Live'],
        text: (
            <p>
                Nach der Kontaktaufnahme wird in einem Kick-off ermittelt, wie eProcurement Sie in Ihrem
                Beschaffungsprozess potenziell unterstützen kann. Danach wird in der Konzeptionierungsphase untersucht,
                wie und mit welchem Aufwand die Umsetzung aussehen kann. Nach einer erfolgreichen Testing-Phase kann auf
                den neuen Beschaffungsprozess umgestellt werden.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Verfügbarkeitsschnittstelle',
            icon: <IconVerfuegbarkeitsschnittstelle />,
            intro: 'Abrufen der Verfügbarkeiten zu Ihren disponierten Ersatzteilen über die Schnittstelle direkt in Ihr Kundensystem.',
            text: (
                <p>
                    Über die Verfügbarkeitsschnittstelle können Sie die frei verfügbaren Mengen für Ihre benötigten
                    Ersatzteile abrufen. Hierbei sind nicht nur die Verfügbarkeiten Ihres OMNIplus Servicestützpunktes,
                    sondern über die gesamte Lieferkette einsehbar.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ihre Vorteile',
                    list: [
                        'Vollständige Transparenz über verfügbare Liefermengen bei Ihrem OMNIplus Servicestützpunkt',
                        'Anzeige der Verfügbarkeit in der gesamten Logistikkette',
                        'Bessere Planbarkeit im Beschaffungsprozess',
                        'Aufruf über eine REST API Schnittstelle',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: 'Bestellschnittstelle',
            icon: <IconBestellschnittstelle />,
            intro: 'Bestellungen direkt an OMNIplus senden.',
            text: (
                <p>
                    Die Integration einer Bestellschnittstelle ermöglicht es, Bestellaufträge direkt an das System von
                    OMNIplus zu übermitteln. So entsteht beim Bestellen im Kundensystem kein Systembruch. Es entfällt
                    das manuelle Übertragen der Bestellinhalte, damit der Auftrag schneller und exakt wie übermittelt
                    verarbeitet wird. Die Verbindung über eine Schnittstelle kann derzeit zu den Daimler Buses eigenen
                    Service Centern mit BusWorld Klassifizierung aufgebaut werden.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ihre Vorteile',
                    list: [
                        'Digitale Ersatzteilbeschaffung ohne Systembruch',
                        'Schnellere Verarbeitung der Bestellung durch direkte Auftragsanlage im Daimler Buses Service Center',
                        'Übermittlung einer Auftragsbestätigung über die Schnittstelle möglich',
                        'Anbindungsvielfalt: Verbindung möglich über EDI-Standards, cXML oder eine REST API Schnittstelle',
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Katalogschnittstelle',
            icon: <IconKatalogschnittstelle />,
            intro: 'Einfache Identifikation der benötigten Ersatzteile ohne Verlassen des Kundensystems.',
            text: (
                <p>
                    Über eine Katalogschnittstelle können im OMNIplus eShop Ersatzteile identifiziert und in das
                    Kundensystem übertragen werden. Im OMNIplus eShop Katalog sind Ihre kunden&shy;individuelle Preise
                    sowie die Verfügbarkeit bei Ihrem OMNIplus Servicestützpunkt ersichtlich.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ihre Vorteile',
                    list: [
                        'Integration des kundenspezifischen Fuhrparks im OMNIplus eShop',
                        'Verfügbarkeiten sowie individuelle Preise direkt einsehbar',
                        'Ersatzteilsuche über vier unterschiedliche Wege, zum Beispiel über die Fahrzeugdokumentation im BusParts Catalog',
                        'Unterstützung des OCI und cXML Standards',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Nettopreisschnittstelle',
            icon: <IconNettopreisschnittstelle />,
            intro: 'Abrufen Ihrer kundenspezifischen Ersatzteilpreise über die Schnittstelle direkt in Ihr Kundensystem.',
            text: (
                <>
                    <p>
                        Über die Nettopreisschnittstelle können Sie die Preise für Ihre Ersatzteile direkt aus dem
                        System von OMNIplus in Ihr Kundensystem übertragen. Hierbei werden Ihre kundenindividuellen
                        Konditionen und Sonderaktionen berücksichtigt. Die Preisabfrage ist dabei bei allen Daimler
                        Buses eigenen Service Centern mit BusWorld Klassifizierung möglich.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ihre Vorteile',
                    list: [
                        'Anzeige des Preises unter Berücksichtigung Ihrer individuellen Konditionen für die disponierten Ersatzteile',
                        'Vollständige Preistransparenz auch bei Sonderpreisen und Staffelrabatten',
                        'Bestell- und Freigabeprozess vollständig im Kundensystem möglich',
                        'Aufruf über eine REST API Schnittstelle',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: 'Teileidentifikation über die Katalogschnittstelle',
            headlineWidth: 780,
            infoBox: {
                headline: 'Anwendungsfall',
                bullets: [
                    'Sie suchen für Ihr Fahrzeug ein Ersatzteil, wobei Ihnen die zu bestellende Teilenummer nicht bekannt ist. Beispielsweise weil es sich um ein neues Fahrzeugmodell handelt oder das benötigte Ersatzteil nicht in Ihrer kundeneigenen Datenbank hinterlegt ist.',
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: 'Aufruf des OMNIplus eShop Katalogs',
                    content: (
                        <>
                            Innerhalb Ihres kundeneigenen Warenwirtschafts&shy;systems kann der OMNIplus eShop Katalog
                            aufgerufen werden, um die Ersatzteilidentifikation zu starten.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: 'Teileidentifikation über den OMNIplus eShop',
                    content: (
                        <>
                            In der eShop Oberfläche kann auf insgesamt vier verschiedenen Wegen das benötigte
                            Ersatzteil identifiziert werden. So bietet der eShop neben der Integration des individuellen
                            Fuhrparks auch beispielsweise die Ersatzteilsuche über die Fahrzeug&shy;dokumentation im
                            BusParts Catalog.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Transfer ins Kundensystem',
                    content:
                        'Nach der Identifikation der benötigten Ersatzteile und dem Zusammenstellen des Warenkorbinhalts können die Teileinformationen aus dem OMNIplus eShop in das Kundensystem übertragen werden.',
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Bestellung aus dem Kundensystem',
                    content: (
                        <>
                            Über die Bestellschnittstelle wird Ihre Bestellung mit einem Klick an das System von
                            OMNIplus übermittelt und kann direkt ver&shy;arbeitet werden.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline: 'Disposition bekannter Ersatzteile mithilfe von Verfügbarkeits- und Preisschnittstelle',
            headlineWidth: 1210,
            infoBox: {
                headline: 'Anwendungsfall',
                bullets: [
                    'In vielen Fällen ist bereits bekannt, welche Ersatzteile Sie benötigen.',
                    'Dies ist beispielsweise der Fall, wenn die Ersatzteilidentifikation bereits in der Werkstatt erfolgt und in Ihrem System ein Bestellauftrag mit den benötigten Teilenummern angelegt wird.',
                    <>
                        Oder Sie erhalten eine Meldung in Ihrem Warenwirtschaftssystem, dass der Mindest&shy;bestand von
                        einzelnen Teilen unterschritten wird. Wenn die Lieferantennummern bereits im Materialstamm
                        gepflegt sind, können Sie im Folgenden eine Lagerergänzung veranlassen.
                    </>,
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Disposition der zu beschaffenden Ersatzteile', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'In Ihrem Warenwirtschaftssystem disponieren Sie die benötigten Ersatzteile in einem Bestellauftrag, etwa um Lagerergänzungen durchzuführen.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Abrufen von Verfügbarkeit und Preis',
                    content: (
                        <>
                            Nach Anlage eines Bestellauftrages in Ihrem Kunden&shy;system mit den zu beschaffenden
                            Ersatzteilen können Sie die zugehörigen Verfügbarkeiten und Preise über die
                            eProcurement-Schnittstelle abrufen.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: 'Prüfung des Bestellauftrages',
                    content:
                        'In Ihrem Kundensystem können Sie die abgerufenen Informationen zu den disponierten Ersatzteilen anzeigen lassen und ggf. Ihre internen Freigabeprozesse anstoßen.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Bestellung aus dem Kundensystem',
                    content:
                        'Anschließend können Sie über die Bestellschnittstelle Ihren Auftrag an das System von OMNIplus übermitteln, sodass dieser direkt verarbeitet werden kann.',
                },
            ],
        },
    },
};
